import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { CountdownTimer } from './CountdownTimer';
import { FlowLine } from './FlowLine';
export function BonusSection() {
  return <section className="border-y border-brand-line bg-brand-blush px-4 py-20 sm:py-28" data-id="element-18" data-mp="22diuckgrth4h">
      <div className="mx-auto max-w-6xl" data-id="element-19" data-mp="1yet802dr8p8p">
        <div className="text-center" data-id="element-20" data-mp="1ao7ah51dmncy">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-deep" data-id="element-21" data-mp="1ap8mbbq7vdvq">
            Et ce n’est pas tout
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-brand-ink sm:text-4xl" data-id="element-22" data-mp="15njf67647kcx">
            Les 5 bonus professionnels
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-brand-muted" data-id="element-23" data-mp="1epsjugepcjie">
            Chaque bonus complète le système principal en répondant à une autre
            situation concrète du travail du professeur.
          </p>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-24" data-mp="mws676q1hvz2">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col overflow-hidden rounded-xl border border-brand-line bg-white shadow-card ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-25" data-mp="2er67iz0g3vj5" data-mpi={index}>
              <div className="flex items-center justify-between gap-3 border-b border-brand-line bg-brand-cream px-6 py-4" data-id="element-26" data-mp="20qdekipsl8i5">
                <span className="font-display text-2xl font-semibold text-brand-deep" data-id="element-27" data-mp="25rsyu8k5bazh">
                  BONUS {bonus.id}
                </span>
                <span className="flex h-10 w-10 items-center justify-center rounded-full border border-brand-gold/50 bg-brand-goldSoft text-brand-gold" data-id="element-28" data-mp="3h554mozgu3oa">
                  <GiftIcon size={18} aria-hidden="true" data-id="element-29" data-mp="1h1kgq8pdfd0i" />
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-30" data-mp="1c42h58x8ua56">
                <h3 className="text-xl font-semibold leading-snug text-brand-ink" data-id="element-31" data-mp="1q4d80byjzoqc">
                  {bonus.title}
                </h3>
                {bonus.intro.map(paragraph => <p key={paragraph} className="mt-3 text-sm leading-6 text-brand-muted" data-id="element-32" data-mp="yce5f6qwpnoq">
                    {paragraph}
                  </p>)}
                {bonus.situations && <p className="mt-2 text-sm font-medium leading-6 text-brand-ink" data-id="element-33" data-mp="177bx6aibiueh">
                    {bonus.situations.join(' ')}
                  </p>}
                <p className="mt-4 text-sm font-medium text-brand-ink" data-id="element-34" data-mp="endg3hg4bbwu">
                  {bonus.listLabel}
                </p>
                <ul className="mt-2.5 flex flex-wrap gap-1.5" data-id="element-35" data-mp="aligqihqz8lp">
                  {bonus.bullets.map(bullet => <li key={bullet} className="rounded-full border border-brand-rose/50 bg-brand-blush px-2.5 py-1 text-xs font-medium text-brand-ink" data-id="element-36" data-mp="5a4ozhqa08qp">
                      {bullet}
                    </li>)}
                </ul>
                <FlowLine className="mt-5" label={bonus.flow.label} steps={bonus.flow.steps} data-id="element-37" data-mp="j9cpcdy6dmwh" />
                <p className="mt-auto pt-6" data-id="element-38" data-mp="o6wa7wpdoxxe">
                  <span className="inline-flex rounded-md bg-brand-goldSoft px-3 py-1.5 text-xs font-bold uppercase tracking-[0.08em] text-brand-ink" data-id="element-39" data-mp="9chq1su2vih5">
                    Inclus sans coût supplémentaire
                  </span>
                </p>
              </div>
            </motion.article>)}
        </div>
        <CountdownTimer data-id="element-40" data-mp="2z1tgybyvieh2" />
      </div>
    </section>;
}